import React from "react";
import classNames from "classnames";
import TextInput from "../inputs/TextInput";

const AddressFull = ({
	register,
	error,
	required = false,
	className = "",
	id,
	errors,
}) => {
	return (
		<div className={classNames("address-form", className)}>
			<TextInput
				label="Address Line 1"
				{...register(`${id}_address_line_1`, {
					required: required ? "Address Line 1 is required" : false,
				})}
				placeholder="House number and street"
				required={required}
				error={errors?.[`${id}_address_line_1`]}
			/>

			<TextInput
				label="Address Line 2"
				{...register(`${id}_address_line_2`)}
				placeholder="Apartment, suite, etc. (optional)"
				required={false}
			/>

			<TextInput
				label="Town/City"
				{...register(`${id}_town`, {
					required: required ? "Town/City is required" : false,
				})}
				placeholder="Town or city"
				required={required}
				error={errors?.[`${id}_town`]}
			/>

			<TextInput
				label="County"
				{...register(`${id}_county`, {
					required: required ? "County is required" : false,
				})}
				placeholder="County"
				required={required}
				error={errors?.[`${id}_county`]}
			/>

			<TextInput
				label="Postcode"
				{...register(`${id}_postcode`, {
					required: required ? "Postcode is required" : false,
				})}
				placeholder="Postcode"
				required={required}
				error={errors?.[`${id}_postcode`]}
			/>

			<TextInput
				label="Country"
				{...register(`${id}_country`, {
					required: required ? "Country is required" : false,
				})}
				placeholder="Country"
				required={required}
				error={errors?.[`${id}_country`]}
			/>

			{/* Show main address field error if it exists */}
			{error && <div className="field__error">{error.message || error}</div>}
		</div>
	);
};

export default AddressFull;
